import slugify from 'slugify';

export function generateNameFromText(text) {
  return slugify(text, { lower: true });
}
